import React from 'react'
import './heating.less'
import { setHeader } from '@/util/set-header'
import { List, Toast, Stepper } from 'antd-mobile'
import SelectPay from '../common/select-pay/select-pay'
import Checkbox from '@/components/checkbox/checkbox'
import { fetchPayBase } from '@/api/payment'
import { connect } from 'react-redux'
import PayGroup from './../common/pay-group'
import * as util from '@/util/util'
const AStepper: any = Stepper

const Item = List.Item
const mapStateToProps = (state: any) => {
  return {
    payment: state.payment,
  }
}
@(connect(mapStateToProps) as any)
class Heating extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      info: {},
      heating: {},
      bill_type: 'day',
      bill_text: '日付',
      bill_price: '1',
      cycle: 1,
      payType: 'alipay',
      store_no: '',
      room_no: '',
      bed_no: '',
    }
  }

  leftClick = () => {
    //返回App
    const { history } = this.props
    if(history.length>1){
      history.goBack()
    }else{
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '缴费', leftClick: this.leftClick })
    Toast.loading('加载中', 0)
  }
  componentDidMount() {

    const { payment } = this.props
    if (payment.checkin_id) {
      this.getBaseInfo(payment.checkin_id)
    }
  }

  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.payment
    const { payment } = this.props
    if (nextInfo.checkin_id === '') {
      Toast.info('您当前可能还未入住，请入住后在缴费哦~', 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    if (payment.checkin_id !== nextInfo.checkin_id) {
      this.getBaseInfo(nextInfo.checkin_id)
    }
  }
  //获取费用基本信息
  getBaseInfo = async (checkin_id: string) => {
    let { data } = await fetchPayBase(checkin_id)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    const { info, heating } = data.data

    this.setState({
      info,
      heating,
      store_no: data.data.info.store_no,
      room_no: data.data.info.room_no,
      bed_no: data.data.info.bed_no,
      bill_price: util.toDecimal2(info.heating_fee_info.day_price),
    })
  }
  stepperChange = (num: any) => {
    this.setState({ cycle: num })
  }

  billChange = (bill_type: string) => {
    let bill_text = ''
    let bill_price = 0
    switch (bill_type) {
      case 'day':
        bill_text = '日付'
        bill_price = util.toDecimal2(
          this.state.info.heating_fee_info.day_price,
        )
        break
      case 'month':
        bill_text = '月付'
        bill_price = util.toDecimal2(
          this.state.info.heating_fee_info.month_price,
        )
        break
    }
    this.setState({
      bill_type,
      bill_text,
      bill_price,
    })
  }

  payTypeChange = (payType: string) => {
    this.setState({
      payType: payType,
    })
  }
  get totalAmount(): number {
    const { bill_price, cycle } = this.state
    let totalAmount = 0
    if (cycle) {
      totalAmount = util.numMulti(bill_price, cycle)
      //保留两位小数
      totalAmount = util.toDecimal2(totalAmount)
    }

    return totalAmount
  }
  loadData = () => {
    const { cycle, bill_type, payType, heating } = this.state
    const { subject_id, subject_name } = heating
    return {
      pay_type: payType,
      cost_data: [
        {
          money: this.totalAmount,
          type: bill_type,
          cycle,
          subject_id,
          subject_name,
        },
      ],
    }
  }

  _handleBlur() {
    window.scroll(0, 0);
  }

  render() {
    const { totalAmount } = this
    const { name } = this.props.payment
    return (
      <List className="heating">
        <div className="list">
          <Item extra={<span className="black_cor">{name}</span>}>缴费人</Item>

          <Item
            extra={
              <span className="black_cor">{`${this.state.store_no}-${
                this.state.room_no
              }-${this.state.bed_no}`}</span>
            }
          >
            房间号
          </Item>

          <Item
            style={{ marginTop: '0.1rem' }}
            extra={<span className="red_cor">暖气费</span>}
          >
            缴费项目
          </Item>
          <Item extra={<span className="red_cor">{this.state.bill_text}</span>}>
            计费周期
          </Item>
          <Item
            className="bag"
            onClick={() => this.billChange('day')}
            extra={<Checkbox checked={this.state.bill_type === 'day'} />}
          >
            日付
          </Item>
          <Item
            className="bag"
            onClick={() => this.billChange('month')}
            extra={<Checkbox checked={this.state.bill_type === 'month'} />}
          >
            月付
          </Item>
          <Item
            extra={<span className="black_cor">{this.state.bill_price}元</span>}
          >
            周期单价
          </Item>
          <Item
            extra={
              <AStepper
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={1}
                value={this.state.cycle}
                onChange={this.stepperChange}
                onBlur={this._handleBlur}
              />
            }
          >
            缴费周期
          </Item>
          <SelectPay
            payType={this.state.payType}
            onChange={this.payTypeChange}
          />
        </div>

        <PayGroup money={totalAmount} loadData={this.loadData} />
      </List>
    )
  }
}

export default Heating
